import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faCircleExclamation } from "@fortawesome/pro-regular-svg-icons";
import classNames from "classnames";
import { valueToString } from "helpers/Helpers";
import "components/bookingPopUp/auditTrailNote/AuditTrailNote.scss";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import moment from "moment";

/**
 * @param {string} title title of the action performed
 * @param {any} author user logged in when action happened
 * @param {any} actions more details about actions performed on the booking
 * @param {string} action action performed on the booking - create, modify, delete, notification
 * @param {string} timestamp time the action took place
 * @param {boolean} last check for last note in array of Audit Trail Notes
 */

export interface ILogsInventory {
  title: string;
  action: string;
  last: boolean;
  description: string;
  previous_quantity: number;
  new_quantity: number;
  created_at: string;
}

function InventoryLogs(props: ILogsInventory) {
  const [inventoryState] = useState<ILogsInventory>({
    title: props.title,
    action: props.action,
    last: props.last,
    description: props.description,
    previous_quantity: props.previous_quantity,
    new_quantity: props.new_quantity,
    created_at: props.created_at,
  });

  let icon: IconDefinition = null;

  if (inventoryState?.action === "received") {
    icon = faCheckCircle;
  } else if (inventoryState?.action === "manual_adjustment") {
    icon = faCircleExclamation;
  }

  return (
    <div>
      <div className="bm-audit-trail-note-container">
        <div className="bm-audit-circle-line-container">
          <div
            className={classNames({
              "bm-audit-trail-circle-add": inventoryState.action === "received",
              "bm-audit-trail-circle-modify": inventoryState.action === "manual_adjustment",
            })}
          >
            <FontAwesomeIcon
              icon={icon}
              className={classNames({
                "bm-audit-trail-circle-add_icon": inventoryState.action === "received",
                "bm-audit-trail-circle-modify_icon": inventoryState.action === "manual_adjustment",
              })}
            />
          </div>
        </div>

        <div className="bm-audit-note-action-container">
          <div className="flex flex-col">
            <p className="bm-audit-trail-action-title">{valueToString(inventoryState.title)}</p>
            <div>
              <p className="bm-audit-trail-action-description">
                <span>
                  {inventoryState.description}{" "}
                  {inventoryState.action === "manual_adjustment" ? "from:" : "Adjusted from:"}{" "}
                  {inventoryState.previous_quantity ?? 0} <FontAwesomeIcon icon={["far", "arrow-right"]} />{" "}
                  {inventoryState.new_quantity ?? 0}
                </span>
              </p>
            </div>
          </div>
          <p className="bm-audit-trail-action-logs">{moment(inventoryState.created_at).format("LLL")}</p>
        </div>
      </div>

      {!inventoryState.last ? <div className="bm-audit-trail-line"></div> : null}
    </div>
  );
}

export default InventoryLogs;
